import React        from 'react';
import PropTypes    from 'prop-types';
import ReloadHelper from '../../../utils/ReloadHelper';

class ContentLink extends React.PureComponent {
	constructor(props) {
		super(props);

		this.onClickHandler = this.onClickHandler.bind(this);
	}

	/**
	 * @param {Event} e
	 */
	onClickHandler(e) {
		ReloadHelper.reload(this.props.link, e);
	}

	render() {
		const {children, enabled, link} = this.props;

		if (!enabled) {
			return <span>{children}</span>;
		}

		return (
			<a target='_blank' className='dailybonus__content-link' href={link} onClick={this.onClickHandler}>
				{children}
			</a>
		);
	}
}

ContentLink.propTypes = {
	children: PropTypes.node,
	enabled:  PropTypes.bool,
	link:     PropTypes.string,
};

ContentLink.defaultProps = {
	children: '',
	enabled:  false,
	link:     '',
};

export default ContentLink;